import { STORE_TYPES } from '~/constants/store'
import httpClient from '~/modules/core/httpClient'

const url = {
  ORGANIZATIONS: '/organizations',
  ORG_CREATE: '/organizations/create/',
  ORG_READ: '/organizations/read/',
  ORG_UPDATE: '/organizations/update/',
}

const ACTIONS = {
  READ_SS_CREDENTIALS: 'read_ss_credentials',
  BATCH_SS_CREDENTIALS: 'batch_ss_credentials',
}

const create = ({ organization_name }) =>
  httpClient.post(url.ORG_CREATE, () => ({ organization_name }))

const get = ({ organizations_list }) =>
  httpClient.post(url.ORG_READ, () => ({ organizations_list }))

const update = ({ organization_name }) =>
  httpClient.post(url.ORG_UPDATE, ({ organization_id }) => ({
    organization_id,
    organization_name,
  }))

const readSSCredentials = () =>
  httpClient.post(url.ORGANIZATIONS, ({ organization_id, store_id }) => ({
    organization_id,
    store_id,
    action: ACTIONS.READ_SS_CREDENTIALS,
    parameters: {},
  }))

const batchSSCredentials = (params) =>
  httpClient.post(url.ORGANIZATIONS, {
    action: ACTIONS.BATCH_SS_CREDENTIALS,
    parameters: params,
  })

const organizationApi = {
  create,
  get,
  update,
  readSSCredentials,
  batchSSCredentials,
}

export default organizationApi

// new apis for pantry sites
// This api is used to link a draft location to real POS location
export const linkPOS = (
  orgId: string,
  {
    posType,
    covaCompanyId,
    covaUsername,
    covaPassword,
    covaClientId,
    covaClientSecret,
    greenlineCompanyId,
  }: {
    // common
    posType: string
    // cova store
    covaCompanyId?: string
    covaUsername?: string
    covaPassword?: string
    covaClientId?: string
    covaClientSecret?: string
    // greenline store
    greenlineCompanyId?: string
  },
) =>
  httpClient.json.post(`/organizations/${orgId}/link-pos`, {
    pos_type: posType,
    ...(covaCompanyId ? { cova_company_id: covaCompanyId } : {}),
    ...(covaUsername ? { cova_username: covaUsername } : {}),
    ...(covaPassword ? { cova_password: covaPassword } : {}),
    ...(covaClientId ? { cova_client_id: covaClientId } : {}),
    ...(covaClientSecret ? { cova_client_secret: covaClientSecret } : {}),
    ...(greenlineCompanyId ? { greenline_company_id: greenlineCompanyId } : {}),
  })

// This api is used to create a POS workspace
export const createPOSWorkspace = (
  workspaceName: string,
  storeType: string,
  posGreenlineUsingTaxV2?: boolean,
  createPantrySite?: boolean,
) =>
  httpClient.json.post(`/organizations/create-pos-org`, {
    organization_name: workspaceName,
    pos_type: storeType,
    // Greenline-only flag: never send it for other store types
    ...(storeType === STORE_TYPES.GREENLINE &&
    posGreenlineUsingTaxV2 !== undefined
      ? { pos_greenline_using_tax_v2: posGreenlineUsingTaxV2 }
      : {}),
    // Store-type-agnostic: send whenever defined
    ...(createPantrySite !== undefined
      ? { create_pantry_site: createPantrySite }
      : {}),
  })

// This api is used to get the POS locations for a workspace
export const getPOSLocations = (orgId: string) =>
  httpClient.json.get(`/organizations/${orgId}/pos-locations`)

// This api is to create a draft warehouse
export const createDraftWarehouse = (
  orgId: string,
  warehouseData: {
    name: string
    address_1: string
    address_2: string
    city: string
    state: string
    postal_code: string
    country: string
    phone_number: string
    license: string
    location_status: string
  },
) =>
  httpClient.json.post(
    `/organizations/${orgId}/pantry-warehouses`,
    warehouseData,
  )

// This api is to connect a draft pantry warehouse to real pos location
export const linkPantryWarehouseToPOS = (
  orgId: string,
  warehouseId: string,
  posId: string,
) =>
  httpClient.json.post(
    `/organizations/${orgId}/pantry-warehouses/${warehouseId}/link-pos`,
    {
      pos_id: posId,
    },
  )

export const enableMockPOS = (orgId: string) =>
  httpClient.json.post(`/organizations/${orgId}/mock-pos`, {})

export const removeMockPOS = (orgId: string) =>
  httpClient.json.delete(`/organizations/${orgId}/mock-pos`)
